import Layout from "@/components/v2/organisms/landing/layout/Layout";
import SEOHead from "@/components/SEOHead";
import PropertyManagementContactForm from "@/components/v2/molecules/landing/property-management/PropertyManagementContactForm";
import PropertyManagementHeader from "@/components/v2/molecules/landing/property-management/PropertyManagementHeader";
import PropertyManagementServices from "@/components/v2/molecules/landing/property-management/PropertyManagementServices";
import PropertyManagementStats from "@/components/v2/molecules/landing/property-management/PropertyManagementStats";
import PropertyManagmentExtraServices from "@/components/v2/molecules/landing/property-management/PropertyManagmentExtraServices";
import PropertyManagementCTA from "@/components/v2/molecules/landing/property-management/PropertyManagementCTA";
import { Helmet } from "react-helmet-async";

const PropertyManagement = () => {
  return (
    <Layout>
      <Helmet>
        <script>{`function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-17260472983/oai5CM-e04QbEJfVt6ZA',
      'value': 1.0,
      'currency': 'MXN',
      'event_callback': callback
  });
  return false;
}`}</script>
      </Helmet>
      <SEOHead
        title="Administración de propiedades vacacionales"
        description="Estancia Corta administramos propiedades vacacionales. Maximizamos ingresos de los propietarios y brindamos una gran experiencia para los huéspedes."
      />

      <div id="top" />
      <PropertyManagementHeader />
      <div className="md:hidden max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <PropertyManagementContactForm embedded />
      </div>
      <PropertyManagementStats />
      <PropertyManagementServices />
      <PropertyManagmentExtraServices />
      <PropertyManagementCTA />
    </Layout>
  );
};

export default PropertyManagement;
